import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from "recharts";
import { Star } from "lucide-react";

export function FreshnessGauge({ score = 0, size = 180, label = "FRESHNESS SCORE" }) {
  const data = [{ name: "score", value: score, fill: "#10B981" }];
  const stars = Math.round(score / 20);
  return (
    <div className="flex flex-col items-center" data-testid="freshness-gauge">
      <div style={{ width: size, height: size }} className="relative">
        <ResponsiveContainer>
          <RadialBarChart
            innerRadius="70%" outerRadius="100%"
            barSize={12} data={data} startAngle={90} endAngle={-270}
          >
            <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
            <RadialBar background={{ fill: "#E2E8F0" }} dataKey="value" cornerRadius={20} />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="font-serif text-4xl text-[#0A1128] leading-none" data-testid="freshness-score-value">
            {score}
          </div>
          <div className="text-[10px] tracking-[0.24em] text-slate-500 mt-1">/ 100</div>
        </div>
      </div>
      <div className="mt-3 flex items-center gap-1" data-testid="freshness-stars">
        {[0,1,2,3,4].map((i) => (
          <Star key={i} className={`w-4 h-4 ${i < stars ? "text-[#D4AF37] fill-[#D4AF37]" : "text-slate-300"}`} />
        ))}
      </div>
      <div className="text-[10px] tracking-[0.28em] text-slate-500 mt-2 uppercase">{label}</div>
    </div>
  );
}
